import React, { useEffect } from "react";

// =============================================================================
// GhlReviewsWidget — Drain Sights Google reviews carousel (GoHighLevel /
// Reputation Hub embed).
//
// The widget itself (layout = Carousel / auto-scroll, transparent background,
// header removed) is configured entirely inside the GHL Reputation widget
// builder — we only render the iframe + load GHL's companion script, which
// auto-sizes the iframe height via postMessage (same pattern as the quote
// form's `form_embed.js`).
//
// FADE EDGES: the wrapper carries `abc-marquee-mask` — the SAME horizontal
// gradient mask used by our native review marquee — so the left/right edges of
// the auto-scrolling carousel fade out and match the rest of the site.
// (Masking is a client-side compositing effect, so it works fine on the
// cross-origin iframe; we can't reach inside the iframe, but we can fade it.)
// =============================================================================

const WIDGET_SRC = "https://reputationhub.site/reputation/widgets/review_widget/5KyyopxwuCSmxe7OSJ45";
const SCRIPT_SRC = "https://reputationhub.site/reputation/assets/review-widget.js";
const SCRIPT_MARKER = "data-ghl-reviews-widget";

export default function GhlReviewsWidget() {
  useEffect(() => {
    if (typeof document === "undefined") return;
    // Inject GHL's review-widget script once (idempotent across StrictMode
    // double-mount and route transitions). It scans for `.lc_reviews_widget`
    // iframes and keeps their height in sync with the widget content.
    if (!document.querySelector(`script[${SCRIPT_MARKER}]`)) {
      const s = document.createElement("script");
      s.src = SCRIPT_SRC;
      s.type = "text/javascript";
      s.async = true;
      s.setAttribute(SCRIPT_MARKER, "");
      document.body.appendChild(s);
    }
  }, []);

  return (
    <div className="abc-marquee-mask" data-testid="ghl-reviews-widget">
      <iframe
        title="Google reviews for Drain Sights"
        className="lc_reviews_widget"
        src={WIDGET_SRC}
        frameBorder="0"
        scrolling="no"
        style={{ minWidth: "100%", width: "100%", minHeight: "320px", border: 0, display: "block" }}
      />
    </div>
  );
}
